import { 
  tmsEventCallListAvailableMeetings,
  IAvailableMeeting,
  IMeetingUserInfo,
  EventType
} from '@app/model';

// 重新导出类型供组件使用
export type AvailableMeeting = IAvailableMeeting;
export type MeetingUserInfo = IMeetingUserInfo;
export type { EventType };

/**
 * 获取用户可参与的音视频会议列表
 */
export async function getAvailableMeetings(): Promise<AvailableMeeting[]> {
  try {
    const response = await tmsEventCallListAvailableMeetings({
      params: {}, // 空参数对象
      handler: { printLog: true }
    });

    // console.log('📺 Meeting API response:', response);

    // 检查响应状态
    if (response.err || !response.shellIsOk || !response.dataIsOk) {
      const errorMessage = response.err?.message || 'Failed to fetch available meetings';
      throw new Error(errorMessage);
    }

    if(!response.data?.data) {

    }
    // 检查业务逻辑状态
    if (!response.data?.is_ok) {
      throw new Error(response.data?.data.msg || 'Business logic error');
    }

    return response.data.meetings;
  } catch (error) {
    console.error('📺 Error fetching available meetings:', error);
    throw error;
  }
}

/**
 * 根据shortcode构建会议URL
 */
export function buildMeetingUrl(shortCode: string, role: 'initiator' | 'responder', eventType?: string): string {
  const baseUrl = '/join-call';
  let url = `${baseUrl}?code=${shortCode}&role=${role}`;
  if (eventType) {
    url += `&eventType=${eventType}`;
  }
  return url;
}

/**
 * 格式化会议创建时间
 */
export function formatMeetingTime(timestamp: number): string {
  const date = new Date(timestamp * 1000);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMins / 60);

  if (diffMins < 1) {
    return '刚刚';
  } else if (diffMins < 60) {
    return `${diffMins}分钟前`;
  } else if (diffHours < 24) {
    return `${diffHours}小时前`;
  } else {
    return date.toLocaleDateString('zh-CN', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
}

/**
 * 获取会议角色的显示文本
 */
export function getRoleDisplayText(role: 'initiator' | 'responder'): string {
  return role === 'initiator' ? '发起者' : '受邀者';
}

/**
 * 获取事件类型的显示文本和颜色
 */
export function getEventTypeInfo(eventType: EventType | string): { text: string; color: string; icon: string } {
  switch (eventType?.toLowerCase()) {
    case 'medical':
      return { text: '医疗呼救', color: '#2196f3', icon: '🏥' };
    case 'security':
      return { text: '安全呼救', color: '#f44336', icon: '🚨' };
    default:
      return { text: eventType || '未知', color: '#757575', icon: '📞' };
  }
}
export function getMeetingStatusInfo(status: string): { text: string; color: string } {
  switch (status.toLowerCase()) {
    case 'active':
    case 'in_progress':
      return { text: '进行中', color: '#4caf50' };
    case 'waiting':
      return { text: '等待中', color: '#ff9800' };
    case 'ended':
      return { text: '已结束', color: '#757575' };
    default:
      return { text: status, color: '#757575' };
  }
}